export const errorMsg = {
  text: 'We could not populate the specification right now. Please try again later.',
  key: 'populate-specification',
};
